import { DtAttachment } from '@ow/ditto-core'

const { validation, transformer } = DtAttachment
// export { default as transformer } from './transformer'
// export { default as validation } from './validation'
export { default as Render } from './render'
// export { config } from './config'
export { validation, transformer }
